import Component from './Component';
import { initFavButton } from '../lib/FavButtonsHelper';

// iniFavButton function available globally for Optimizely extensions.
window.satc.initFavButton = initFavButton;

// favourite button logic
// let thisComponent = null;
export default class FavButton extends Component {

  load() {
    // thisComponent = this;  // store "this" on class load.
    // console.log('favourites.');

    initFavButton();
    super.load();
  }


}

